/**
 * Declarative link tracking for Event 4: pals_request_rep_click
 * Listens for clicks on elements with data-track="request-rep" (links matching request|rep|contact)
 */

import {useEffect} from 'react';
import * as track from './tracking';
import {useTracking} from './TrackingContext';

const REQUEST_REP_SELECTOR = '[data-track="request-rep"]';

/**
 * Sets up document-level click listener for request/rep/contact links.
 * Call once in the app (e.g. Pal page) when inside TrackingProvider.
 * Re-runs when enhanced tracking is toggled so the listener is not stuck with [] deps.
 */
export const useLinkTracking = () => {
  const {enhancedTrackingEnabled} = useTracking();

  useEffect(() => {
    if (!enhancedTrackingEnabled || !track.shouldTrack()) {
      return;
    }

    const handleClick = (e) => {
      if (!track.shouldTrack()) {
        return;
      }
      const el = e.target.closest(REQUEST_REP_SELECTOR);
      if (!el) {
        return;
      }

      const linkName = el.getAttribute('data-track-label') || el.textContent?.trim() || '';
      const linkUrl = el.href || el.getAttribute('href') || '';

      track.requestRepClick({
        link_name: linkName,
        link_url: linkUrl
      });
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [enhancedTrackingEnabled]);
}
